function triggerAddingToCartEvent() {
	const event = new CustomEvent("wc-blocks_adding_to_cart", {
		bubbles: true,
		cancelable: true,
	});
	document.body.dispatchEvent(event);
};

window.triggerAddingToCartEvent = triggerAddingToCartEvent;

function triggerAddedToCartEvent({ preserveCartData = false }) {
	const event = new CustomEvent("wc-blocks_added_to_cart", {
		bubbles: true,
		cancelable: true,
		detail: { preserveCartData },
	});
	document.body.dispatchEvent(event);
};

window.triggerAddedToCartEvent = triggerAddedToCartEvent;

export function init() {
	const miniCartButtons = document.querySelectorAll('button.wc-block-mini-cart__button');

	if (!miniCartButtons.length) {
		return;
	}

	const setupMiniCartButton = function(button) {

		// There is an issue with the cart drawer not loading a close button when opened on mobile,
		// here we try to make sure the button is loaded.
		button.addEventListener('click', function(event) {
			triggerAddingToCartEvent();

			window.requestAnimationFrame(() => {
				window.requestAnimationFrame(() => {
					window.requestAnimationFrame(() => {
						window.requestAnimationFrame(() => {
							window.requestAnimationFrame(() => {
								window.requestAnimationFrame(() => {
									window.requestAnimationFrame(() => {
										window.requestAnimationFrame(() => {
											console.log('extra check')
											const closeButton = document.querySelector('.wc-block-mini-cart__drawer .wc-block-components-drawer__close');

											if (!closeButton) {
												triggerAddedToCartEvent({ preserveCartData: false });
											}
										});
									});
								});
							});
						});
					});
				});
			});
		})
	}

	miniCartButtons.forEach(setupMiniCartButton);
}
